import React from "react";
import Lottie from "lottie-react";
import styled from "styled-components";
import heroLottieJson from "lottie/hero.json";
import heroMobileLottieJson from "lottie/heroMobile.json";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

const HeroLottie = () => {
  return (
    <Container>
      {/* {isMobile ? (
        <Lottie animationData={heroMobileLottieJson} loop={true} />
      ) : (
        <Lottie animationData={heroLottieJson} loop={true} />
      )} */}
      <Lottie animationData={heroLottieJson} loop={true} />
    </Container>
  );
};

export default HeroLottie;

const Container = styled.div`
  width: 100%;
`;
